import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import Seo, { BreadcrumbJsonLd } from "@/components/common/Seo";
import { Reveal } from "@/components/common/Reveal";
import { api } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)).catch(() => setPosts([])); }, []);

  return (
    <div data-testid="blog-page">
      <Seo title="Car Detailing Tips & Guides for Ottawa Drivers | Reverence Autos"
        description="Expert car detailing guides for Ottawa: pricing, ceramic coating, winter care, interior vs exterior detailing and more. From the Reverence Autos crew." path="/blog" />
      <BreadcrumbJsonLd items={[{ name: "Home", path: "/" }, { name: "Blog", path: "/blog" }]} />
      <section className="bg-brand-offwhite">
        <div className="container-rv py-20 lg:py-28">
          <Reveal>
            <p className="overline text-brand-red">The Reverence Journal</p>
            <h1 className="mt-4 max-w-3xl font-serif text-5xl font-bold leading-tight text-brand-charcoal sm:text-6xl">Care tips, protection guides & shine secrets</h1>
          </Reveal>
        </div>
      </section>
      <section className="bg-white">
        <div className="container-rv py-20 lg:py-28">
          {posts === null ? (
            <div className="flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-brand-red" /></div>
          ) : (
            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {posts.map((p, i) => (
                <Reveal key={p.slug} delay={(i % 3) * 0.08}>
                  <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group flex h-full flex-col overflow-hidden rounded-2xl border border-brand-silver/40 bg-white transition-[transform,box-shadow] hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-40px_rgba(26,28,30,0.5)]">
                    <div className="overflow-hidden">
                      <img src={p.image} alt={p.title} loading="lazy" className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    </div>
                    <div className="flex flex-1 flex-col p-6">
                      <span className="overline text-brand-red">{p.tags?.[0]} · {p.read_min} min</span>
                      <h3 className="mt-3 font-serif text-xl font-bold leading-snug text-brand-charcoal">{p.title}</h3>
                      <p className="mt-3 flex-1 text-sm text-brand-muted">{p.excerpt}</p>
                      <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-brand-red">Read article <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
